import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/services-usa/woocommerce/why-choose.webp";

function Whychooseecommerce() {
  return (
    <section
      className="trusted_ecommerce_web ecommerce_why_choose p-100"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <h2 style={{ color: "#fff" }}>
              Why Choose TekRevol as Your WooCommerce Web Design & Development
              Company?
            </h2>
            <Link
              style={{ background: "#f47a1f", color: "#fff" }}
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Start WooCommerce Web Development
            </Link>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="mt-3 mt-md-0">
            <p style={{ color: "#fff" }}>
              TekRevol builds high-performing WooCommerce websites that drive
              measurable business outcomes. As a WooCommerce website design
              agency, we focus on secure, scalable, and conversion-optimized
              solutions for sustainable online presence. Our development process
              is engineered for precision—from seamless user experiences to
              robust backend systems. Trust TekRevol to transform your
              WooCommerce site into a powerful revenue-generating platform.
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <Row className="mt-3 mt-md-5">
              <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-4">
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">01</div>
                  <div className="ecomm_box_content">
                    <h5>
                      Custom
                      <br />
                      WooCommerce Design
                    </h5>
                    <p>
                      Build conversion-focused designs to increase user
                      engagement and sales.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-4">
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">02</div>
                  <div className="ecomm_box_content">
                    <h5>
                      Abandoned Cart
                      <br /> Recovery
                    </h5>
                    <p>
                      Implement automated recovery tools to reclaim lost sales
                      and boost revenue.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-4">
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">03</div>
                  <div className="ecomm_box_content">
                    <h5>
                      Secure Payment
                      <br /> Systems
                    </h5>
                    <p>
                      Deploy encrypted payment gateways to protect transactions
                      and build customer trust.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-4">
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">04</div>
                  <div className="ecomm_box_content">
                    <h5>
                      Conversion Rate
                      <br /> Optimization
                    </h5>
                    <p>
                      Use data-driven strategies to refine user journeys and
                      maximize purchase completions.
                    </p>
                  </div>
                </div>
              </Col>
              <Col
                xs={12}
                md={6}
                lg={6}
                xl={3}
                xxl={3}
                className="mb-xl-0 mb-4"
              >
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">05</div>
                  <div className="ecomm_box_content">
                    <h5>
                      High-Speed
                      <br /> Performance
                    </h5>
                    <p>
                      Enhance load times for better user experience and reduced
                      bounce rates.
                    </p>
                  </div>
                </div>
              </Col>
              <Col
                xs={12}
                md={6}
                lg={6}
                xl={3}
                xxl={3}
                className="mb-xl-0 mb-4"
              >
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">06</div>
                  <div className="ecomm_box_content">
                    <h5>
                      Advanced SEO
                      <br /> Techniques
                    </h5>
                    <p>
                      Optimize for higher search rankings to attract targeted
                      organic traffic.
                    </p>
                  </div>
                </div>
              </Col>
              <Col
                xs={12}
                md={6}
                lg={6}
                xl={3}
                xxl={3}
                className="mb-4 mb-md-0"
              >
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">07</div>
                  <div className="ecomm_box_content">
                    <h5>
                      Streamlined
                      <br /> Checkout Process
                    </h5>
                    <p>
                      Simplify checkout to reduce friction and increase order
                      completion rates.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">08</div>
                  <div className="ecomm_box_content">
                    <h5>
                      Ongoing Support &
                      <br /> Maintenance
                    </h5>
                    <p>
                      Provide continuous monitoring to ensure peak performance
                      and security.
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Whychooseecommerce;
